import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { videos } from '../mockData';

const VideoSection = () => {
  const { language } = useLanguage();
  const [selectedVideo, setSelectedVideo] = useState(null);

  const content = {
    en: {
      title: "See Our Professional Team in Action",
      subtitle: "Watch how we transform spaces with meticulous attention to detail"
    },
    gr: {
      title: "Δείτε την Επαγγελματική μας Ομάδα σε Δράση",
      subtitle: "Δείτε πώς μεταμορφώνουμε τους χώρους με σχολαστική προσοχή στη λεπτομέρεια"
    }
  };

  const t = content[language];

  return (
    <section className="pad-2xl">
      <div className="container">
        <div className="text-center mb-12 animate-fadeInUp">
          <h2 className="heading-2 mb-4">{t.title}</h2>
          <p className="body-medium max-w-2xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
            {t.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {videos.map((videoUrl, index) => (
            <div 
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-xl cursor-pointer group"
              onClick={() => setSelectedVideo(videoUrl)}
            >
              <video
                className="w-full h-auto"
                style={{ maxHeight: '500px', objectFit: 'cover' }}
                muted
                playsInline
              >
                <source src={videoUrl} type="video/mp4" />
              </video>
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <div className="w-0 h-0 border-l-[20px] border-l-blue-500 border-t-[12px] border-t-transparent border-b-[12px] border-b-transparent ml-1"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Video Modal */}
        {selectedVideo && (
          <div 
            className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
            onClick={() => setSelectedVideo(null)}
          >
            <div className="relative w-full max-w-4xl">
              <button
                onClick={() => setSelectedVideo(null)}
                className="absolute -top-12 right-0 text-white text-4xl hover:text-gray-300"
              >
                ×
              </button>
              <video
                controls
                autoPlay
                className="w-full h-auto rounded-lg"
                onClick={(e) => e.stopPropagation()}
              >
                <source src={selectedVideo} type="video/mp4" />
              </video>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default VideoSection;
